import React from "react";
import Task from "./task";

const tasks = ({ tasks, handleTaskClick, Removetask, HandleClickTaskDetails}) =>{
    return (
        <>
            {tasks.map(task => ( 
            <Task key={task.id} task = {task} handleTaskClick={handleTaskClick} Removetask={Removetask} HandleClickTaskDetails={HandleClickTaskDetails}/>
            ))}
        </>
    )
}

export default tasks